<template>
  <div id="app">
    <el-form
      style="margin-top: 15px"
      size="small"
      :inline="true"
      :model="search"
    >
      <el-form-item>
        <el-date-picker
          style="width: 250px;margin-left:25px"
          v-model="search.start_end"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="daterange"
          start-placeholder="start time"
          end-placeholder="end time"
          :default-time="['00:00:00', '23:59:59']"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="to_search()">search</el-button>
      </el-form-item>
    </el-form>
    <div id="daily_active" style="width: 100%; height: 500px"></div>
  </div>
</template>
<script>
export default {
  name: "DailyActive",
  components: {},
  data() {
    return {
      myChart: null,
      allcount:0,
      search: {
        start: this.getNextDate(-7)+" 00:00:00",
        end: this.getNextDate(0)+" 23:59:59",
        start_end:[this.getNextDate(-7)+" 00:00:00",this.getNextDate(0)+" 23:59:59"],
      },
    };
  },
  methods: {
    getNextDate: function (day) {
      var dd = new Date();
      dd.setDate(dd.getDate() + day);
      var y = dd.getFullYear();
      var m =
        dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
      return y + "-" + m + "-" + d;
    },
    to_search() {
      if (this.search.start_end) {
        this.search.start =this.search.start_end["0"];
        this.search.end =this.search.start_end["1"]; 
      } else {
        this.search.start = this.getNextDate(-7)+" 00:00:00";
        this.search.end = this.getNextDate(0)+" 23:59:59";
      }
      this.getData(false);
    },
    getData(isfirst=true) {
      this.$api.rootV1.post(
        "/web/statistics/login",this.search,
        (res) => {
          if (res.errcode == 0) {
            let data = res.data;
            let dates = [],
              totalCounts = [],allcount=0;
            for (let item of data) {
              dates.push(item.date);
              allcount=allcount + item.totalCount*1;
              totalCounts.push(item.totalCount);
            }
            this.allcount=allcount
            this.dates = dates;
            this.totalCounts = totalCounts;
            this.drawChart(isfirst,dates, totalCounts);
          }
        }
      );
    },
    drawChart(isfirst,dates, totalCounts) {
      let myChart=null;
      if(isfirst){
        var echarts = require("echarts");
        // 基于准备好的dom，初始化echarts实例
        myChart = echarts.init(document.getElementById("daily_active"));
        this.myChart=myChart;
      }else{
        myChart=this.myChart;
      }
      // 指定图表的配置项和数据
      let option = {
        title: { text: "Daily active devices (totalcount: "+this.allcount+")" },
        tooltip: {},
        xAxis: {
          type: "category",
          data: dates,
        },
        yAxis: { type: "value" },
        series: [
          {
            type: "line",
            data: totalCounts,
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/main/statistics/DailyActive.vue